<app-tab [items]="items" [selectedIndex]="selectedItemIndex" (onTabChange)="tabChange($event)"></app-tab>

<ng-template #clinicProfile>
  <app-appointment-schedule *ngIf="tabLoaded[0] || selectedItemIndex === 0"></app-appointment-schedule>
</ng-template>

<ng-template #clinicServices>
  <app-clinic-services *ngIf="tabLoaded[1] || selectedItemIndex === 1"></app-clinic-services>
</ng-template>

<ng-template #prescriptionTemplate>
  <app-appointment-prescription *ngIf="tabLoaded[2] || selectedItemIndex === 2"></app-appointment-prescription>
</ng-template>

<ng-template #reportsTemplate>
  <app-appointment-reports *ngIf="tabLoaded[2] || selectedItemIndex === 2"></app-appointment-reports>
</ng-template>